
import React, { useState, useEffect } from 'react';

const ICONS = ['💻', '📱', '💿', '💾', '🖱️', '⌨️', '🔋', '📡'];

const Memory: React.FC = () => {
  const [cards, setCards] = useState<{ icon: string, id: number, isFlipped: boolean, isMatched: boolean }[]>([]);
  const [flipped, setFlipped] = useState<number[]>([]);
  const [moves, setMoves] = useState(0);

  const init = () => {
    const deck = [...ICONS, ...ICONS]
      .sort(() => Math.random() - 0.5)
      .map((icon, idx) => ({ icon, id: idx, isFlipped: false, isMatched: false }));
    setCards(deck);
    setFlipped([]);
    setMoves(0);
  };

  useEffect(() => init(), []);

  const handleFlip = (idx: number) => {
    if (flipped.length === 2 || cards[idx].isFlipped || cards[idx].isMatched) return;

    const newFlipped = [...flipped, idx];
    const newCards = [...cards];
    newCards[idx].isFlipped = true;
    setCards(newCards);
    setFlipped(newFlipped);

    if (newFlipped.length === 2) {
      setMoves(m => m + 1);
      const [first, second] = newFlipped;
      if (cards[first].icon === cards[second].icon) {
        newCards[first].isMatched = true;
        newCards[second].isMatched = true;
        setFlipped([]);
      } else {
        setTimeout(() => {
          newCards[first].isFlipped = false;
          newCards[second].isFlipped = false;
          setCards([...newCards]);
          setFlipped([]);
        }, 800);
      }
    }
  };

  const isComplete = cards.length > 0 && cards.every(c => c.isMatched);

  return (
    <div className="flex flex-col items-center game-container">
      <div className="mb-8 flex justify-between w-full max-w-lg items-center glass p-6 rounded-3xl">
        <div className="flex flex-col">
          <span className="text-[10px] uppercase font-bold text-slate-500 tracking-widest">Efficiency</span>
          <span className="text-3xl font-black text-purple-400">{moves} <span className="text-sm font-normal text-slate-600">tries</span></span>
        </div>
        {isComplete && (
          <button onClick={init} className="bg-purple-600 hover:bg-purple-500 px-8 py-3 rounded-2xl font-bold shadow-xl shadow-purple-500/20 active:scale-95 transition-all">
            SYNC AGAIN
          </button>
        )}
      </div>

      <div className="grid grid-cols-4 gap-4 p-4 bg-slate-900/50 rounded-[2.5rem] border border-slate-800 shadow-2xl">
        {cards.map((card, idx) => (
          <button
            key={idx}
            onClick={() => handleFlip(idx)}
            className={`w-20 h-20 md:w-28 md:h-28 rounded-3xl flex items-center justify-center text-5xl transition-all duration-500 transform-gpu relative ${
              card.isFlipped || card.isMatched 
                ? 'rotate-y-180 bg-slate-800 ring-4 ring-purple-500/30' 
                : 'bg-gradient-to-br from-slate-800 to-slate-900 hover:from-slate-700 hover:to-slate-800 ring-1 ring-white/5 shadow-lg active:scale-90'
            }`}
          >
            <div className={`transition-opacity duration-300 ${card.isFlipped || card.isMatched ? 'opacity-100' : 'opacity-0'}`}>
              {card.icon}
            </div>
            {!(card.isFlipped || card.isMatched) && (
              <div className="absolute inset-0 flex items-center justify-center text-slate-600 text-2xl font-black opacity-20">
                //
              </div>
            )}
          </button>
        ))}
      </div>
    </div>
  );
};

export default Memory;
